import SmkAsyncSelectGraphql from 'components/SmkAsyncSelect/customSelectGraphql';
import { FOOD_ITEMS_SEARCH } from 'containers/nutrition/graphql/food_item.query';
import { RECIPE_SEARCH } from 'containers/nutrition/graphql/recipe.query';
import { isEmpty } from 'lodash';
import React, { useEffect, useRef, useState } from 'react';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { Button, Card, CardBody, CardTitle, Col, FormFeedback, FormGroup, Input, Label, Row } from 'reactstrap';

const MultipleItems = ({ unitsList, formik, keyName, mealPlanDetails }) => {
  const [item, setItem] = useState({
    isFoodItem: false,
    foodItem: '',
    recipe: '',
    amount: '',
    amountUnit: null,
    calories: '',
  });

  const [addeditemsList, setAddeditemsList] = useState([]);
  const isFirstRender = useRef(true);

  const handleChange = (e) => {
    const { name, value, type } = e.target;

    setItem((prev) => ({
      ...prev,
      [name]: type === 'number' && value !== '' ? Number(value) : value,
    }));
  };

  const handleAddItem = () => {
    const isAllValuesNotEmpty = (item.foodItem || item.recipe) && item.amount && item.amountUnit && item.calories;

    if (isAllValuesNotEmpty) {
      setAddeditemsList((prev) => [item, ...(prev || [])]);
      // reset form
      setItem({
        isFoodItem: item.isFoodItem,
        foodItem: '',
        recipe: '',
        amount: '',
        amountUnit: null,
        calories: '',
      });
    } else {
      toast.error('Please fill all fields before adding!');
    }
  };

  const handleDeleteItem = (index) => {
    setAddeditemsList((prev) => prev.filter((_, i) => i !== index));
  };

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    formik.setFieldValue(keyName, addeditemsList);
  }, [addeditemsList]);

  useEffect(() => {
    if (!isEmpty(mealPlanDetails)) {
      const data = !isEmpty(mealPlanDetails?.items)
        ? mealPlanDetails?.items?.map((e) => ({
            amount: e?.amount,
            amountUnit: e?.amountUnit,
            calories: e?.calories,
            ...(!isEmpty(e?.recipe) ? { recipe: e?.recipe } : {}),
            ...(!isEmpty(e?.foodItem) ? { foodItem: e?.foodItem } : {}),
            isFoodItem: !isEmpty(e?.foodItem),
          }))
        : null;

      setAddeditemsList(data);
    }
  }, [mealPlanDetails]);

  return (
    <Card className="mb-4">
      <CardBody>
        <h5 className="bg-light p-3 mb-4 text-center rounded-2">Items</h5>

        {/* Input Form */}
        <div className="border rounded-2 p-4 mb-4">
          <Row className="align-items-center">
            <Col md={12}>
              {[true, false].map((option, i) => (
                <div key={`is_food_item_${i}`} className="form-check mb-3 d-inline-block me-4">
                  <input
                    type="radio"
                    id={`is_food_item_${option}`}
                    name="isFoodItem"
                    className="form-check-input"
                    checked={item.isFoodItem === option}
                    onChange={(e) => {
                      setItem((prev) => ({
                        ...prev,
                        isFoodItem: option,
                        foodItem: option ? prev.foodItem : '',
                        recipe: option ? '' : prev.recipe,
                      }));
                    }}
                  />
                  <label className="form-check-label" htmlFor={`is_food_item_${option}`}>
                    {option ? 'Food Item' : 'Recipe'}
                  </label>
                </div>
              ))}
            </Col>

            {item?.isFoodItem ? (
              <Col md={12}>
                <FormGroup className="mb-4">
                  <Label for="itemFoodItem" className="form-label  ">
                    Food Item <span className="text-danger">*</span>
                  </Label>
                  <SmkAsyncSelectGraphql
                    isClearable={true}
                    acceptedKey="name"
                    acceptedValue="id"
                    placeholder="Type food item name..."
                    searchKeyName="name"
                    query={FOOD_ITEMS_SEARCH}
                    queryName="admin_nutrition_foodItem_search"
                    dtoName="searchDTO"
                    filters={{
                      autoComplete: true,
                      active: true,
                      page: 1,
                      size: 500,
                      sortBy: 'id',
                      sortOrder: 0,
                    }}
                    value={
                      !isEmpty(item.foodItem)
                        ? {
                            label: item.foodItem?.name,
                            value: item.foodItem?.slug,
                          }
                        : null
                    }
                    onChange={(data) => {
                      setItem((prev) => ({
                        ...prev,
                        foodItem: data,
                      }));
                    }}
                  />
                  <FormFeedback className="d-block">{formik.errors.itemFoodItem}</FormFeedback>
                </FormGroup>
              </Col>
            ) : (
              <Col md={12}>
                <FormGroup className="mb-4">
                  <Label for="itemRecipe" className="form-label  ">
                    Recipe <span className="text-danger">*</span>
                  </Label>
                  <SmkAsyncSelectGraphql
                    isClearable={true}
                    acceptedKey="name"
                    acceptedValue="id"
                    placeholder="Type recipe name..."
                    searchKeyName="name"
                    query={RECIPE_SEARCH}
                    queryName={'admin_nutrition_recipe_search'}
                    dtoName="searchDTO"
                    filters={{
                      autoComplete: true,
                      active: true,
                      page: 1,
                      size: 500,
                      sortBy: 'id',
                      sortOrder: 0,
                    }}
                    value={
                      !isEmpty(item.recipe)
                        ? {
                            label: item.recipe?.name,
                            value: item.recipe?.slug,
                          }
                        : null
                    }
                    onChange={(data) => {
                      setItem((prev) => ({
                        ...prev,
                        recipe: data,
                      }));
                    }}
                  />
                  <FormFeedback className="d-block">{formik.errors.itemRecipe}</FormFeedback>
                </FormGroup>
              </Col>
            )}

            <Col md={4}>
              <FormGroup className="mb-4">
                <Label for="amount">
                  Amount
                  <span className="text-danger">*</span>
                </Label>
                <Input
                  id="amount"
                  name="amount"
                  type="text"
                  placeholder="Enter amount..."
                  value={item?.amount}
                  onChange={handleChange}
                />
              </FormGroup>
            </Col>

            <Col md={4}>
              <FormGroup className="mb-4">
                <Label for="amountUnit">
                  Amount Unit <span className="text-danger">*</span>
                </Label>
                <Select
                  id="amountUnit"
                  options={unitsList}
                  value={unitsList?.find((e) => e?.value?.toLowerCase() === item.amountUnit?.toLowerCase()) || null}
                  onChange={(val) => {
                    setItem((prev) => ({ ...prev, amountUnit: val?.value || null }));
                  }}
                />
              </FormGroup>
            </Col>

            <Col md={4}>
              <FormGroup className="mb-4">
                <Label for="calories">
                  Calories <span className="text-danger">*</span>
                </Label>
                <Input
                  id="calories"
                  name="calories"
                  type="number"
                  placeholder="Enter calories..."
                  value={item.calories}
                  onChange={handleChange}
                />
              </FormGroup>
            </Col>
          </Row>

          <Button color="dark" className="w-100 mt-3" onClick={handleAddItem}>
            Add Portion
          </Button>
        </div>

        {!isEmpty(addeditemsList) && (
          <div className="border rounded-2 p-4 bg-light">
            <h6 className="mb-3">Added Items:</h6>
            <div className="row">
              {addeditemsList?.map((p, idx) => (
                <div className="col-md-4" key={`items_${idx}`}>
                  <div className="border p-3 rounded-2 mb-4 bg-white">
                    <div className="d-flex gap-3">
                      <div className="mb-2">
                        <strong>{idx + 1}.</strong>
                      </div>
                      <div>
                        {p?.isFoodItem ? (
                          <div>
                            Food Item:<strong className="ms-2"> {p.foodItem?.name}</strong>
                          </div>
                        ) : (
                          <div>
                            Recipe: <strong className="ms-2">{p.recipe?.name}</strong>
                          </div>
                        )}

                        <div>
                          Amount:{' '}
                          <strong className="ms-2">
                            {p.amount} {p.amountUnit}
                          </strong>
                        </div>
                        <div>
                          Calories: <strong className="ms-2">{p.calories}</strong>
                        </div>
                      </div>
                    </div>
                    <div className="mt-3">
                      <Button className="w-100" color="danger" size="sm" onClick={() => handleDeleteItem(idx)}>
                        Delete
                      </Button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </CardBody>
    </Card>
  );
};

export default MultipleItems;
